export const colors = {
  blue: "#226FE2",
  buttonCompany: "#22303E",
  darkBlue: "#0f489d",
};
